import { onDocumentReady } from '@pratt/js/utils';

onDocumentReady(() => {
  const tagFeatureRoot = document.querySelector('.js-tag-feature');
  if (tagFeatureRoot) {
    import(/* webpackChunkName: "tag-feature" */ './components/tag-feature').then(module => {
      const TagFeature = module.default;
      new TagFeature(tagFeatureRoot);
    });
  }

  const courseSearchRoot = document.querySelector('.js-course-search');
  if (courseSearchRoot) {
    import(/* webpackChunkName: "course-search" */ './components/algolia/course-search').then(
      module => {
        const CourseSearch = module.default;
        new CourseSearch(courseSearchRoot);
      },
    );
  }

  const eventSearchRoot = document.querySelector('.js-event-search');
  if (eventSearchRoot) {
    import(/* webpackChunkName: "event-search" */ './components/algolia/event-search').then(
      module => {
        const EventSearch = module.default;
        new EventSearch(eventSearchRoot);
      },
    );
  }

  const personSearchRoot = document.querySelector('.js-person-search');
  if (personSearchRoot) {
    import(/* webpackChunkName: "person-search" */ './components/algolia/person-search').then(
      module => {
        const PersonSearch = module.default;
        new PersonSearch(personSearchRoot);
      },
    );
  }

  const prattfolioStorySearchRoot = document.querySelector('.js-prattfolio-story-search');
  if (prattfolioStorySearchRoot) {
    import(
      /* webpackChunkName: "prattfolio-story-search" */ './components/algolia/prattfolio-story-search'
    ).then(module => {
      const PrattfolioStorySearch = module.default;
      new PrattfolioStorySearch(prattfolioStorySearchRoot);
    });
  }

  const pressSearchRoot = document.querySelector('.js-press-search');
  if (pressSearchRoot) {
    import(/* webpackChunkName: "press-search" */ './components/algolia/press-search').then(
      module => {
        const PressSearch = module.default;
        new PressSearch(pressSearchRoot);
      },
    );
  }

  const programTabsRoot = document.querySelector('.js-program-tabs');
  if (programTabsRoot) {
    import(/* webpackChunkName: "program-tabs" */ './components/program-tabs').then(module => {
      const ProgramTabs = module.default;
      new ProgramTabs(programTabsRoot, 'horizontal');
    });
  }

  const resourcePolicyServiceSearchRoot = document.querySelector(
    '.js-resource-policy-service-search',
  );
  if (resourcePolicyServiceSearchRoot) {
    import(
      /* webpackChunkName: "resource-policy-service-search" */ './components/algolia/resource-policy-service-search'
    ).then(module => {
      const ResourcePolicyServiceSearch = module.default;
      new ResourcePolicyServiceSearch(resourcePolicyServiceSearchRoot);
    });
  }

  const tagSearchRoot = document.querySelector('.js-tag-search');
  if (tagSearchRoot) {
    import(/* webpackChunkName: "search" */ './components/algolia/tag-search').then(module => {
      const TagSearch = module.default;
      new TagSearch(tagSearchRoot);
    });
  }

  const workSearchRoot = document.querySelector('.js-work-search');
  if (workSearchRoot) {
    import(/* webpackChunkName: "work-search" */ './components/algolia/work-search').then(
      module => {
        const WorkSearch = module.default;
        new WorkSearch(workSearchRoot);
      },
    );
  }

  // This is an example of how to do code splitting. The JS in this
  // referenced file will only be loaded on that page. Good for
  // when you have a large amount of JS only needed in one place
  //
  //  if (document.querySelector('#js-process')) {
  //    import(/* webpackChunkName: "process" */ './pages/process')
  //      .then(module => {
  //        const Process = module.default;
  //        this.process = new Process();
  //      });
  //  }
});

// Enables hot module replacement with Webpack
// https://webpack.js.org/guides/hot-module-replacement/
if (module.hot) {
  module.hot.accept();
}
